import { ModalComponent } from '../components/modal/modal.component';
import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogClose } from '@angular/material/dialog';

@Component({
  selector: 'app-forgot-password-confirmation-modal',
  templateUrl: './forgot-password-confirmation-modal.component.html',
  styleUrl: './forgot-password-confirmation-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ModalComponent, MatDialogClose]
})
export class ForgotPasswordConfirmationModalComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: any
  ) {}
}
